import { render } from "./CompletedNFRs.vue?vue&type=template&id=064ca933"
import script from "./CompletedNFRs.vue?vue&type=script&lang=js"
export * from "./CompletedNFRs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__